export default {
  ADDITIONALS: 'additionals',
  ADDONS: 'addons',
  SERVICES: 'services',
  TEMPLATES: 'templates',
  EDUCATIONAL: 'educational',
  PLANS: 'plans',
};
